import "./src/styles/custom.css";

export const onRouteUpdate = ({ location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0);
  }
};

export const onInitialClientRender = () => {
  window.addEventListener('popstate', () => {
    window.scrollTo(0, 0);
  });

  // Load canvas.js only once to prevent redeclaration errors
  if (typeof window !== 'undefined') {
    // Check if canvas.js is already loaded by checking for window.lenis (created by canvas.js)
    const canvasJsAlreadyLoaded = typeof window.lenis !== 'undefined' ||
      typeof window.lenisVersion !== 'undefined' ||
      document.querySelector('script[src="/js/canvas.js"]') !== null ||
      window.__canvasJsLoaded;

    if (!canvasJsAlreadyLoaded) {
      window.__canvasJsLoaded = true; // Set flag immediately to prevent race conditions

      const script = document.createElement('script');
      script.src = '/js/canvas.js';
      script.async = false; // Load synchronously to prevent multiple loads
      script.onerror = () => {
        console.error('Failed to load canvas.js');
        window.__canvasJsLoaded = false; // Reset on error
      };
      document.head.appendChild(script);
    }
  }
};
